export default __webpack_public_path__ + "static/media/demoImg.6eb4c426.jpg";